import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static readonly targets = ['input', 'content'];
  static readonly classes = ['hidden'];

  declare inputTargets: HTMLInputElement[];
  declare contentTargets: HTMLElement[];
  declare hiddenClass: string;

  private controllerAttributes: Map<HTMLElement, string> = new Map();

  connect(): void {
    for (const content of this.contentTargets) {
      // Create reference for payment methods data-attribute after page load
      this.controllerAttributes.set(
        content,
        content.dataset.controller as string,
      );
    }
    this.handleSelection();
    this.application.element.addEventListener(
      'turbo:morph',
      this.handleSelection,
    );
  }

  disconnect() {
    this.application.element.removeEventListener(
      'turbo:morph',
      this.handleSelection,
    );
  }

  handleSelection = () => {
    this.setCheckedFromQueryParam();
    this.toggle();
  };

  open = (event: MouseEvent) => {
    const element = event.currentTarget as HTMLElement;
    const input = element.querySelector('input[type="radio"]') as HTMLInputElement;
    if (input) {
      input.checked = true;
      this.toggle();
    }
  };

  toggle = () => {
    for (const [index, input] of this.inputTargets.entries()) {
      const content = this.contentTargets[index];
      if (input.checked) {
        // Restore the original data-controller value when the radio button is selected
        content.dataset.controller = this.controllerAttributes.get(
          content,
        ) as string;
        content.classList.remove(this.hiddenClass);
      } else {
        // Remove the data-controller attribute when the radio button is not selected
        content.dataset.controller = '';
        content.classList.add(this.hiddenClass);
      }
    }
  };

  setCheckedFromQueryParam = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const paymentMethod = urlParams.get('method');

    if (paymentMethod) {
      for (const input of this.inputTargets) {
        input.removeAttribute('checked');
        if (input.value === paymentMethod) {
          input.checked = true;
          return;
        }
      }
    }
  };
}
